module.exports = __webpack_public_path__ + "img/spring_01.546cd125.png";